import React, { useState } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useAbility } from '@casl/react';

import attendanceColumns from '../../components/Attendance/Columns';
import AttendanceDataTable from '../../components/Attendance/AttendanceDataTable';
import { AbilityContext } from '../../config/abilityContext';
import AttendanceImportForm from '../../components/Attendance/AttendanceImportForm';
import { SimpleCenteredModal } from '../../components';
import { importAttendanceRequest, importTemplateAttendanceRequest } from '../../requests/attendances';
import { sendAlert } from '../../actions/utils';
import { downloadFile } from '../../services/utils';

const AttendanceIndex = () => {
  const [moreData, setMoreData] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const dispatch = useDispatch();
  const ability = useAbility(AbilityContext);

  const handleSuccessAction = message => {
    dispatch(sendAlert({ kind: 'success', message }));
    setMoreData(!moreData);
  };

  const handleImportTemplateAttendanceRequest = () => {
    importTemplateAttendanceRequest({
      dispatch,
      successCallback: response => {
        downloadFile(response);
      },
      callback: () => setModalShow(false)
    });
  };

  const handleAttendanceImportRequest = attendance => {
    importAttendanceRequest({
      dispatch,
      params: attendance,
      formData: true,
      successCallback: response => handleSuccessAction(response?.data?.message),
      callback: () => setModalShow(false)
    });
  };

  return (
    <>
      <Row className="m-top mb-3">
        <Col>
          <h2 className="m-top mt-1 mb-0">Registro</h2>
        </Col>
        {ability.can('import', 'Attendance') && (
          <Col md={4} lg={3}>
            <Button variant="primary" block onClick={() => setModalShow(true)}>
              Importar Asistencia
            </Button>
          </Col>
        )}
      </Row>
      <AttendanceDataTable columns={attendanceColumns} moreData={moreData} setMoreData={setMoreData} />
      <SimpleCenteredModal
        title="Importar Asistencias"
        body={
          <>
            <Button className="ml-3" variant="warning" onClick={handleImportTemplateAttendanceRequest}>
              Descargar ejemplo
            </Button>
            <AttendanceImportForm
              formRequest={handleAttendanceImportRequest}
              handleModalClose={() => setModalShow(false)}
            />
          </>
        }
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
      />
    </>
  );
};

export default AttendanceIndex;
